import React, { ReactNode } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useIsMobile } from '../../../../../hooks/useIsMobile'
import { useUnitsString } from '../../../../../hooks/useUnitsString'
import { theme } from '../../../../../theme/theme'
import { Icon, IconChoices } from '../../../../common/Icon'
import {
  Illustration,
  IllustrationChoices,
} from '../../../../common/Illustration'
import {
  IPreApprovedList,
  ISocietiesModel,
} from '../../../../../interfaces/models/societies.interfaces'
import { mediaQueries } from '../../../../../api/media'
import { unitQueries } from '../../../../../api/units'

interface SocietyInviteModalContentProps {
  society: ISocietiesModel | undefined
  preApproved?: IPreApprovedList
}

export const SocietyInviteModalContent = ({
  society,
  preApproved,
}: SocietyInviteModalContentProps): ReactNode => {
  const isMobile = useIsMobile()
  const { data: societyCoverPhoto } = useQuery(
    mediaQueries.getMedia(society?.coverPhotoId)
  )

  const { data: unit } = useQuery(unitQueries.getUnit(preApproved?.unitId))

  const units = unit ? [unit] : []
  const unitString = useUnitsString(units)

  const rows: { icon: IconChoices; text: string | undefined }[] = [
    {
      icon: IconChoices.HOME,
      text: society?.name,
    },
    {
      icon: IconChoices.HOUSEHOLD,
      text: unitString,
    },
  ]

  const illustrationWidth = isMobile ? 305 : 710

  return (
    <div className="h-full w-full">
      {societyCoverPhoto?.url ? (
        <img
          style={{ width: illustrationWidth }}
          src={societyCoverPhoto?.url}
          alt="society banner"
        />
      ) : (
        <Illustration
          width={illustrationWidth}
          illustrationChoice={IllustrationChoices.SOCIETY_PLACEHOLDER}
        />
      )}
      <div className="mt-4 flex flex-col">
        {rows.map((_row) => (
          <div key={_row.text} className="flex items-end space-y-2">
            <Icon icon={_row.icon} />
            <p style={theme.textVariants.base} className="ml-2">
              {_row.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
